import { useMemo } from "react";
import { renderers } from "../renderers";
import { useGetFileMimeType } from "@certa/queries/hooks/common.hook";
import type { FilePreviewDataSource } from "@certa/types";

type UseGetFilePreviewRendererParams = {
  url: string;
  filePreviewDataSource?: FilePreviewDataSource;
  disableMimeTypeCheck?: boolean;
};

export const useGetFilePreviewRenderer = ({
  url,
  filePreviewDataSource,
  disableMimeTypeCheck
}: UseGetFilePreviewRendererParams): {
  DocRendererComp: any;
  isFetchingFileMimeType: boolean;
} => {
  const { isLoading: isFetchingFileMimeType, data: mimeType } =
    useGetFileMimeType(url, filePreviewDataSource, {
      enabled: !!url && !disableMimeTypeCheck,
      refetchOnWindowFocus: false
    });

  const DocRendererComp = useMemo(() => {
    if (isFetchingFileMimeType) {
      return null;
    }
    if (mimeType) {
      const result = renderers.find((previewer: any) => {
        return previewer.mimeTypes.includes(mimeType);
      });
      return result || "NO_RENDERER_FOUND";
    }
  }, [isFetchingFileMimeType, mimeType]);

  return { DocRendererComp, isFetchingFileMimeType };
};
